import clientSDK from '../../App/ClientSDK'

const baseUrl = 'customers/subscriptions'

export type TSortType = 'name' | 'turns' | 'turns_used' | 'sold_at' | 'last_used_at'  | 'subscription_id'
export type TSortDirection = 'asc' | 'desc'
export type TSort = `${TSortType}:${TSortDirection}`
interface IApiCustomerSubscriptionData {
  id: number
  name: string
  customer: {
    id: number
    first_name: string
    last_name: string
  }
  turns: number
  turns_used: number
  sold_at: string
  last_used_at: string
}

const subscriptionListUrl = 'subscriptions'

interface Activity {
  id: number;
  name: string;
  duration: number;
}

export interface IApiCustomerSubscription {
  activity: Activity;
  category: null;
  establishment_id: number;
  id: number;
  name: string;
  price: string;
  turns: number;
}

export const getCustomerSubscriptionData = async (params?: { [k: string]: string; }) => {
  const response = await clientSDK
    .instance()
    .get<{ list: IApiCustomerSubscriptionData[]; meta: { total_amount: number } }>(
      baseUrl,
      params ? { ...params } : undefined,
    )
  const data = response.data
  return {list: data.list, totalAmount: data.meta.total_amount}
}

export const getCustomerSubscriptionInfo = async (establishmentId: string) => {
  const response = await clientSDK
  .instance() 
  .get<IApiCustomerSubscription[]>(subscriptionListUrl, { establishment_id: establishmentId })
  return response.data
}
